import { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

import { useToast } from '@/hooks/use-toast';
import { useAuthStore } from '@/stores/auth-store';

export function OrgContextRoute() {
  const { orgSlug } = useParams<{ orgSlug: string }>();
  const user = useAuthStore((s) => s.user);
  const activeOrgId = useAuthStore((s) => s.activeOrgId);
  const setActiveOrgId = useAuthStore((s) => s.setActiveOrgId);
  const { error } = useToast();

  const membership = user?.memberships.find((m) => m.organizationSlug === orgSlug) ?? null;

  useEffect(() => {
    if (membership && membership.organizationId !== activeOrgId) {
      setActiveOrgId(membership.organizationId);
    }
  }, [membership, activeOrgId, setActiveOrgId]);

  useEffect(() => {
    if (!membership) {
      error('Organization not found', "You don't have access to that organization");
    }
  }, [membership, error]);

  if (!membership) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
